import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { colors, radius } from '../theme';

const API = process.env.REACT_APP_API_URL;
const TIKTOK_AUDITED = process.env.REACT_APP_TIKTOK_AUDITED === 'true';
export const PRIVACY_LABEL = {
  PUBLIC_TO_EVERYONE: 'Publik — semua orang',
  MUTUAL_FOLLOW_FRIENDS: 'Teman — saling mengikuti',
  FOLLOWER_OF_CREATOR: 'Pengikut saya',
  SELF_ONLY: 'Hanya saya (privat)'
};

// tanpaJadwal (2026-10-26): video panjang dijadwalkan lewat tombol Setujui UGC, jadi isian jadwal per akun disembunyikan.
export default function TiktokPostSettings({ accounts, settings, onChange, onCaps, tanpaJadwal = false }) {
  const [caps, setCaps] = useState({});
  const [loading, setLoading] = useState(false);

  const hdr = () => ({ headers: { Authorization: `Bearer ${localStorage.getItem('sm_token')}` } });

  useEffect(() => {
    if (!accounts || accounts.length === 0) return;
    let cancelled = false;
    (async () => {
      setLoading(true);
      const next = {};
      for (const a of accounts) {
        try {
          const r = await axios.get(`${API}/api/tiktok/creator-info/${a.id}`, hdr());
          next[a.id] = r.data;
        } catch (e) {
          next[a.id] = { error: e.response?.data?.error || 'Gagal memuat info kreator' };
        }
      }
      if (!cancelled) { setCaps(next); if (onCaps) onCaps(next); setLoading(false); }
    })();
    return () => { cancelled = true; };
    // Kunci = daftar id, bukan objek array: sejak 2026-10-14 accounts = akun yang dicentang (array baru
    // tiap render). Dengan [accounts] efek ini berjalan terus dan memanggil creator_info TikTok tanpa henti.
  }, [accounts && accounts.map(a => a.id).join(',')]); // eslint-disable-line

  const set = (id, field, val) =>
    onChange({ ...settings, [id]: { ...(settings[id] || {}), [field]: val } });

  if (loading) return <div style={{ fontSize: 12, color: colors.textSecondary, padding: '10px 4px', display: 'flex', alignItems: 'center', gap: 6 }}><i className="ti ti-loader-2" style={{ fontSize: 14 }}></i>Memuat info akun TikTok...</div>;

  return (
    <div>
      {accounts.map(a => {
        const c = caps[a.id] || {};
        const s = settings[a.id] || {};
        const allOpts = c.privacy_level_options || [];
        // Dropdown WAJIB mencerminkan persis privacy_level_options dari creator_info.
        // Jangan pernah difilter: daftar opsi hanya bergantung akun creator privat/publik,
        // BUKAN status audit klien. Memotongnya melanggar Content Posting Guidelines.
        const opts = allOpts;
        const brandedOn = !!(s.is_commercial && s.is_branded_content);

        const declaration = brandedOn
          ? <>Dengan memposting, Anda menyetujui <a href="https://www.tiktok.com/legal/page/global/bc-policy/en" target="_blank" rel="noopener noreferrer" style={{ color: colors.accentText }}>TikTok Branded Content Policy</a> dan <a href="https://www.tiktok.com/legal/page/global/music-usage-confirmation/en" target="_blank" rel="noopener noreferrer" style={{ color: colors.accentText }}>Music Usage Confirmation</a>.</>
          : <>Dengan memposting, Anda menyetujui <a href="https://www.tiktok.com/legal/page/global/music-usage-confirmation/en" target="_blank" rel="noopener noreferrer" style={{ color: colors.accentText }}>TikTok Music Usage Confirmation</a>.</>;

        if (c.error) return (
          <div key={a.id} style={{ padding: 14, background: colors.dangerMuted, border: `1px solid ${colors.danger}`, borderRadius: radius.md, marginBottom: 10, fontSize: 12, color: colors.danger, display: 'flex', alignItems: 'flex-start', gap: 8 }}>
            <i className="ti ti-alert-triangle" style={{ fontSize: 16, flexShrink: 0, marginTop: 1 }}></i>
            <div>
              <strong>{a.username || 'Akun TikTok'}</strong>: {c.error}
              <div style={{ fontSize: 11, color: colors.textSecondary, marginTop: 4 }}>Coba reconnect akun ini, atau hubungi admin jika masalah berlanjut.</div>
            </div>
          </div>
        );

        return (
          <div key={a.id} style={{ padding: 14, background: colors.bgCard, border: `1px solid ${colors.border}`, borderRadius: radius.lg, marginBottom: 12 }}>

            <div style={{ display: 'flex', alignItems: 'center', gap: 10, marginBottom: 12 }}>
              {c.creator_avatar_url && <img src={c.creator_avatar_url} alt="" style={{ width: 34, height: 34, borderRadius: '50%' }} />}
              <div>
                <div style={{ fontSize: 13, fontWeight: 600, color: colors.textPrimary }}>{c.creator_nickname || a.display_name || '—'}</div>
                <div style={{ fontSize: 11, color: colors.textSecondary }}>@{c.creator_username || a.username || '—'}</div>
              </div>
            </div>

            <div style={{ marginBottom: 10 }}>
              <div style={{ fontSize: 11, color: colors.textSecondary, marginBottom: 5 }}>Status Privasi <span style={{ color: colors.danger }}>*</span></div>
              <select value={s.privacy_level || ''} onChange={e => set(a.id, 'privacy_level', e.target.value)} style={{ fontSize: 13 }}>
                <option value="">-- Pilih status privasi --</option>
                {opts.map(o => (
                  <option key={o} value={o} disabled={brandedOn && o === 'SELF_ONLY'}>
                    {PRIVACY_LABEL[o] || o}{brandedOn && o === 'SELF_ONLY' ? ' (tidak tersedia untuk branded content)' : ''}
                  </option>
                ))}
              </select>
              {!s.privacy_level && <div style={{ fontSize: 11, color: colors.danger, marginTop: 5 }}>Wajib dipilih sebelum memposting.</div>}
                            {/* Catatan, BUKAN filter — dropdown di atas tetap utuh sesuai creator_info.
                  Diverifikasi lewat posting sungguhan 24 Sep 2026 di sistem SM Media:
                  selama klien belum lolos Content Posting Audit, TikTok menolak kecuali
                  akun TikTok-nya SENDIRI disetel privat DAN privacy level-nya SELF_ONLY.
                  Setel REACT_APP_TIKTOK_AUDITED=true lalu rebuild begitu audit lolos. */}
              {!TIKTOK_AUDITED && (
                <div style={{ fontSize: 11, color: colors.warning, marginTop: 6, padding: '6px 8px', background: colors.warningMuted, borderRadius: 6, lineHeight: 1.55 }}>
                  Aplikasi belum lolos Content Posting Audit TikTok. Sampai audit selesai, posting cuma berhasil kalau <strong>dua syarat</strong> terpenuhi: akun TikTok tujuan <strong>disetel privat</strong> di aplikasi TikTok, <strong>dan</strong> status privasi di sini dipilih <strong>"Hanya saya (privat)"</strong>.
                </div>
              )}
            </div>

            <div style={{ fontSize: 11, color: colors.textSecondary, marginBottom: 6 }}>Izinkan Interaksi</div>
            <div style={{ display: 'flex', gap: 14, flexWrap: 'wrap', marginBottom: 12 }}>
              {[
                { k: 'allow_comment', cap: 'comment_disabled', label: 'Komentar' },
                { k: 'allow_duet', cap: 'duet_disabled', label: 'Duet' },
                { k: 'allow_stitch', cap: 'stitch_disabled', label: 'Stitch' }
              ].map(it => {
                const off = !!c[it.cap];
                return (
                  <label key={it.k} title={off ? 'Dinonaktifkan pada pengaturan akun TikTok' : ''}
                    style={{ display: 'flex', alignItems: 'center', gap: 6, fontSize: 12, color: off ? colors.textMuted : colors.textSecondary, cursor: off ? 'not-allowed' : 'pointer' }}>
                    <input type="checkbox" disabled={off} checked={!!s[it.k]}
                      onChange={e => set(a.id, it.k, e.target.checked)}
                      style={{ width: 15, height: 15, margin: 0 }} />
                    {it.label}
                  </label>
                );
              })}
            </div>

            {!tanpaJadwal && <div style={{ marginBottom: 12 }}>
              <div style={{ fontSize: 11, color: colors.textSecondary, marginBottom: 5 }}>Jadwal Posting <span style={{ color: colors.textMuted }}>(opsional — kosongkan untuk posting segera)</span></div>
              <input type="datetime-local" value={s.scheduled_at || ''}
                onChange={e => set(a.id, 'scheduled_at', e.target.value)}
                style={{ width: '100%', fontSize: 12, padding: '7px 10px' }} />
            </div>}

            <label style={{ display: 'flex', alignItems: 'center', gap: 7, fontSize: 12, color: colors.textSecondary, marginBottom: 8, cursor: 'pointer' }}>
              <input type="checkbox" checked={!!s.is_commercial}
                onChange={e => set(a.id, 'is_commercial', e.target.checked)}
                style={{ width: 15, height: 15, margin: 0 }} />
              Konten ini mempromosikan produk atau merek
            </label>

            {s.is_commercial && (
              <div style={{ paddingLeft: 20, marginBottom: 10 }}>
                <label style={{ display: 'flex', alignItems: 'center', gap: 7, fontSize: 12, color: colors.textSecondary, marginBottom: 6, cursor: 'pointer' }}>
                  <input type="checkbox" checked={!!s.is_your_brand}
                    onChange={e => set(a.id, 'is_your_brand', e.target.checked)}
                    style={{ width: 15, height: 15, margin: 0 }} />
                  Merek saya sendiri
                </label>
                <label style={{ display: 'flex', alignItems: 'center', gap: 7, fontSize: 12, color: colors.textSecondary, cursor: 'pointer' }}>
                  <input type="checkbox" checked={!!s.is_branded_content}
                    onChange={e => {
                      const v = e.target.checked;
                      const upd = { ...(settings[a.id] || {}), is_branded_content: v };
                      if (v && upd.privacy_level === 'SELF_ONLY') upd.privacy_level = '';
                      onChange({ ...settings, [a.id]: upd });
                    }}
                    style={{ width: 15, height: 15, margin: 0 }} />
                  Konten bermerek (kerja sama berbayar)
                </label>
                {!s.is_your_brand && !s.is_branded_content && (
                  <div style={{ fontSize: 11, color: colors.danger, marginTop: 7, padding: '6px 8px', background: colors.dangerMuted, borderRadius: 6 }}>
                    Pilih minimal satu label di atas. Boleh dua-duanya, tapi tidak boleh kosong.
                  </div>
                )}
              </div>
            )}

            <div style={{ fontSize: 11, color: colors.textSecondary, lineHeight: 1.6, paddingTop: 10, borderTop: `1px solid ${colors.border}` }}>
              {declaration}
            </div>
            <label style={{ display: 'flex', alignItems: 'center', gap: 7, fontSize: 12, color: colors.textSecondary, marginTop: 10, cursor: 'pointer' }}>
              <input type="checkbox" checked={!!s.consent}
                onChange={e => set(a.id, 'consent', e.target.checked)}
                style={{ width: 15, height: 15, margin: 0 }} />
              Saya sudah membaca dan menyetujui kebijakan di atas
            </label>
          </div>
        );
      })}
    </div>
  );
}
